module.exports = __webpack_public_path__ + "img/ukraine.b933ccfd.png";